export const SESSION_VARIABLES = {
  AccessToken: 'AccessToken',
  correlationID: 'correlationID',
  routingKey: 'routingKey',
  Channel: 'Channel',
  Language: 'Language',
  returnURL: 'ReturnURL',
  LogoutURL: 'LogoutURL',
  AFTokenValue: 'AFTokenValue',
  paymentId: 'PaymentId',
  relatedReference: 'RelatedReference',
  deviceAppVersion: 'deviceAppVersion',
  authFlowType: 'authFlowType',
  billpayDeepLink: 'billpayDeepLink'
}

export default SESSION_VARIABLES
